(() => {
  const CUSTOM_ELEMENT_NAME = 'ag-bundle-applications';
  const SLIDER_SELECTOR = '[data-ag-bundle-applications-slider]';
  const MOBILE_MEDIA_QUERY = '(max-width: 767px)';
  const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
  const SPACE_BETWEEN = 24;
  const SLIDE_SPEED = 420;

  class AgBundleApplications extends HTMLElement {
    constructor() {
      super();
      this.isInitialized = false;
      this.slider = null;
      this.swiper = null;
      this.mobileMedia = window.matchMedia(MOBILE_MEDIA_QUERY);
      this.reducedMotion = window.matchMedia(REDUCED_MOTION_QUERY);
      this.sync = this.sync.bind(this);
    }

    connectedCallback() {
      if (this.isInitialized) return;
      this.isInitialized = true;
      this.slider = this.querySelector(SLIDER_SELECTOR);
      this.mobileMedia.addEventListener('change', this.sync);
      window.addEventListener('load', this.sync);
      this.sync();
    }

    disconnectedCallback() {
      if (!this.isInitialized) return;
      this.mobileMedia.removeEventListener('change', this.sync);
      window.removeEventListener('load', this.sync);
      this.destroy();
      this.slider = null;
      this.isInitialized = false;
    }

    sync() {
      if (!this.slider) return;
      const current = this.swiper || this.slider.swiper;
      if (!this.mobileMedia.matches) {
        this.destroy();
        return;
      }
      if (current && !current.destroyed) {
        this.swiper = current;
        return;
      }
      if (typeof window.Swiper === 'undefined') return;
      this.swiper = new window.Swiper(this.slider, {
        slidesPerView: 'auto',
        spaceBetween: SPACE_BETWEEN,
        speed: this.reducedMotion.matches ? 0 : SLIDE_SPEED,
        watchOverflow: true,
        a11y: {
          slideRole: null,
          slideLabelMessage: null,
        },
      });
    }

    destroy() {
      const current = this.swiper || this.slider?.swiper;
      if (current && !current.destroyed) current.destroy(true, true);
      this.swiper = null;
    }
  }

  if (!customElements.get(CUSTOM_ELEMENT_NAME)) {
    customElements.define(CUSTOM_ELEMENT_NAME, AgBundleApplications);
  }
})();
